
import { useParams } from 'react-router-dom';
import ProductDetailHero from './components/ProductDetailHero';
import ProductFeatures from './components/ProductFeatures';
import ProductSpecifications from './components/ProductSpecifications';
import ComplianceSection from './components/ComplianceSection';
import RelatedProducts from './components/RelatedProducts';
import ProductCTA from './components/ProductCTA';

export default function DryChemicalExtinguishersPage() {
  const { id } = useParams();

  const product = {
    id: 5,
    title: 'Dry Chemical Extinguishers',
    category: 'Fire Extinguishers',
    brand: 'FlameGuardQA',
    model: 'FG-ABC-01',
    certification: 'ABC Class Rated',
    status: 'Available',
    image: 'https://readdy.ai/api/search-image?query=Professional%20red%20ABC%20dry%20chemical%20fire%20extinguisher%20with%20pressure%20gauge%20and%20safety%20pin%2C%20multi-purpose%20fire%20suppression%20equipment%20with%20QCDD%20certification%20marking%20and%20clear%20technical%20specifications%20label&width=600&height=600&seq=abc-extinguisher-detail&orientation=squarish',
    description: 'Multi-purpose ABC dry chemical extinguishers suitable for Class A (solid), Class B (liquid), and Class C (gas) fires. The most versatile fire extinguisher for commercial and industrial applications.'
  };

  const features = [
    'Effective on A, B, and C class fires',
    'Corrosion-resistant steel cylinder',
    'High discharge range for safety',
    'Easy recharge and servicing',
    'Monoammonium phosphate dry chemical',
    'Pressure gauge for status monitoring',
    'Wall bracket included',
    'Simple squeeze-grip operation'
  ];

  const specifications = [
    { label: 'Model', value: 'FG-ABC-01' },
    { label: 'Type', value: 'ABC Dry Chemical Extinguisher' },
    { label: 'Capacity', value: '6kg / 9kg / 12kg' },
    { label: 'Propellant', value: 'Nitrogen' },
    { label: 'Working Pressure', value: '15 bar' },
    { label: 'Discharge Time', value: '15–25 seconds' },
    { label: 'Effective Range', value: '3–5 meters' },
    { label: 'Fire Classes', value: 'Class A, B & C' },
    { label: 'Cylinder Material', value: 'Steel with Epoxy Coating' },
    { label: 'Operating Temperature', value: '-30°C to +60°C' },
    { label: 'Weight (9kg)', value: '13.5kg total' },
    { label: 'Certification', value: 'QCDD, ISO' },
    { label: 'Warranty', value: '2 Years' }
  ];

  const relatedProducts = [
    {
      id: 4,
      title: 'CO₂ Fire Extinguishers',
      image: 'https://readdy.ai/api/search-image?query=Professional%20red%20CO2%20fire%20extinguisher%20with%20black%20horn%20and%20pressure%20gauge%2C%20QCDD%20approved%20clean%20agent%20fire%20suppression%20equipment%20for%20electrical%20fires%20with%20technical%20specifications%20label&width=300&height=200&seq=co2-extinguisher-related&orientation=landscape',
      category: 'Extinguishers',
      compliance: 'QCDD Approved'
    },
    {
      id: 6,
      title: 'Foam Fire Extinguishers',
      image: 'https://readdy.ai/api/search-image?query=Professional%20foam%20fire%20extinguisher%20with%20cream%20colored%20body%20and%20red%20components%2C%20AFFF%20fire%20suppression%20equipment%20for%20liquid%20fires%20with%20QCDD%20approval%20and%20technical%20specifications%20label&width=300&height=200&seq=foam-extinguisher-related2&orientation=landscape',
      category: 'Extinguishers',
      compliance: 'AFFF Formula'
    },
    {
      id: 17,
      title: 'Fire Extinguisher Cabinets',
      image: 'https://readdy.ai/api/search-image?query=Red%20steel%20fire%20extinguisher%20cabinet%20with%20glass%20viewing%20window%20and%20lock%2C%20professional%20fire%20safety%20equipment%20storage%20with%20QCDD%20approval%20marking%20mounted%20on%20white%20wall&width=300&height=200&seq=extinguisher-cabinets-related2&orientation=landscape',
      category: 'Accessories',
      compliance: 'Weather Resistant'
    },
    {
      id: 16,
      title: 'Fire Safety Signage',
      image: 'https://readdy.ai/api/search-image?query=Collection%20of%20fire%20safety%20signs%20including%20exit%20signs%2C%20fire%20extinguisher%20location%20signs%20and%20hazard%20warning%20signs%20with%20photoluminescent%20and%20reflective%20materials%2C%20QCDD%20approved%20safety%20signage&width=300&height=200&seq=safety-signs-related2&orientation=landscape',
      category: 'Signage',
      compliance: 'Photoluminescent'
    }
  ];

  return (
    <div className="min-h-screen">
      <ProductDetailHero product={product} />
      <ProductFeatures features={features} />
      <ProductSpecifications specifications={specifications} />
      <ComplianceSection />
      <RelatedProducts products={relatedProducts} />
      <ProductCTA />
      
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-8 right-8 z-50">
        <a 
          href="https://wa.me/97455544093"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center justify-center group"
        >
          <i className="ri-whatsapp-line text-2xl group-hover:scale-110 transition-transform"></i>
        </a>
      </div>
    </div>
  );
}
